import { Fragment } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useClientIdList } from './useClientIdList';

/**
 * รายการ Client ID แบบเพิ่ม/แก้/ลบได้ ใช้ตอนเลือก "RA ต้องอนุมัติคนเข้าองค์กร"
 * เดิม JSX + handler ซ้ำกันเป๊ะทั้งใน CreatePortal.jsx และ EditPortal.jsx
 *
 * หมายเหตุ: ของเดิมใส่ key={index} ไว้ที่ <input> ข้างใน Fragment (<>) ซึ่งไม่มีผล
 * เพราะ key ต้องอยู่ที่ตัว element นอกสุดของแต่ละ item ใน .map() — ย้ายมาไว้ที่
 * Fragment ให้ถูกต้อง โครงสร้าง/สไตล์ที่แสดงผลยังเหมือนเดิมทุกอย่าง
 */
const ClientIdListEditor = ({ clientIDList, setClientIDList, primaryColor }) => {
    const { updateField, removeField, addField } = useClientIdList(clientIDList, setClientIDList);

    return (
        <>
            {clientIDList.map((field, index) => (
                <Fragment key={index}>
                    <input
                        value={field}
                        onChange={(e) => updateField(index, e.target.value)}
                        variant="outlined"
                        style={{
                            width: '75%',
                            maxWidth: '316px',
                            height: '36px',
                            borderRadius: '6px',
                            margin: '10px',
                            marginRight: '5px',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #EEEEEE',
                        }}
                        placeholder="ระบุ Client ID"
                    />
                    <DeleteForeverIcon
                        style={{
                            width: '60px',
                            height: '35px',
                            marginTop: '7px',
                            marginRight: '10px',
                            color: 'red',
                            padding: '2px',
                            cursor: 'pointer',
                        }}
                        onClick={() => removeField(index)}
                    />
                </Fragment>
            ))}
            <button
                style={{
                    width: '140px',
                    height: '35px',
                    marginTop: '7px',
                    border: 'none',
                    backgroundColor: 'white',
                    fontFamily: 'Sarabun',
                    fontWeight: '500',
                    fontSize: '16px',
                }}
                onClick={addField}
            >
                <AddCircleOutlineIcon
                    style={{
                        width: '20px',
                        height: '20px',
                        marginRight: '5px',
                        color: primaryColor,
                    }}
                />
                เพิ่ม Client ID
            </button>
        </>
    );
};

export default ClientIdListEditor;